import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";
import { motion, useReducedMotion, useScroll, useSpring, useTransform, useVelocity } from "framer-motion";

const ITEMS = [
  "Webdesign",
  "Online-Shops",
  "Clothing Design",
  "Clothing Brand Aufbau",
  "UI/UX Design",
  "Landingpages",
  "Prints & Grafiken",
  "Deine Idee. Unsere Umsetzung.",
];

export default function MarqueeStrip() {
  const reduced = useReducedMotion();
  // Der Strip reagiert auf die Scroll-Geschwindigkeit (kinesthetischer Skew)
  const { scrollY } = useScroll();
  const velocity = useVelocity(scrollY);
  const rawSkew = useTransform(velocity, [-2500, 0, 2500], [5, 0, -5]);
  const skewX = useSpring(rawSkew, { stiffness: 200, damping: 30 });

  return (
    <div
      data-testid="service-marquee"
      className="border-y border-black/5 py-6 lg:py-7 overflow-hidden select-none bg-white"
    >
      <motion.div style={reduced ? undefined : { skewX }}>
        <Marquee speed={30} gradient={false} pauseOnHover>
          {ITEMS.map((text, i) => (
            <span key={i} className="flex items-center">
              <span
                className={
                  i % 2 === 0
                    ? "font-display uppercase tracking-tight text-xl lg:text-2xl px-8 marquee-outline"
                    : "font-editorial italic text-xl lg:text-2xl text-zinc-400 px-8 hover:text-gold transition-colors duration-500"
                }
              >
                {text}
              </span>
              <Asterisk size={18} className="text-gold shrink-0 transition-transform duration-500 hover:rotate-90" />
            </span>
          ))}
        </Marquee>
      </motion.div>
    </div>
  );
}
